/*globals google, jQuery */
(function(w,d,$){
  'use strict';
  
  //-----------------------------------
  // googlemap読み込みプラグイン
  // Auther : Ryo kumagai (MP Inc.)
  // URL : www.mpcreative.jp
  // Version : 1.2.0
  //-----------------------------------
  $.fn.googlemap = function(option){
    var _optionTemplate = {
          zoom:14,
          scrollwheel:false,
          mapTypeControl: false,
          zoomControl:false,
          streetViewControl:false,
          tooltip:true,
          markers:[
            {
              title:'',
              address:'',
              latlng:''
            }
          ],
          centerAdjust:{
            lat:6.5,
            lng:15
          },
          styleObj:{
            name:'',
            style:''
          }
        },
        defaultOpt = $.extend(true,_optionTemplate,{ // reset option template
          markers:[''],
          styleObj:[''],
          centerAdjust:false
        }),
        opt = $.extend(true,defaultOpt,option),
        maps_init = (function($,opt,currentInfoWindow){
          var geocoder = (typeof google == 'object')? new google.maps.Geocoder() :{};
          return {
            createMap: function(obj) {
              var _this = this,
                  markers = opt.markers,
                  mapOpts = {
                    zoom : $(obj).data('zoom') || opt.zoom,
                    scrollwheel: opt.scrollwheel,
                    mapTypeControl: opt.mapTypeControl,
                    zoomControl: opt.zoomControl,
                    streetViewControl: opt.streetViewControl
                  };
              var map = new google.maps.Map( obj, mapOpts );
              if(markers.length <= 1 && $(obj).data('address')!=undefined){
                markers[0] = $(obj).data();
              }
              var markerLength = markers.length;
              var $d_setMarker = new $.Deferred;
              var bounds = new google.maps.LatLngBounds();
              var setMarker = function(){
                $.each(markers,function(i,marker){
                  var $d_getAddrs = new $.Deferred;
                  var latlng = [];
                  var is_last = ((i+1) == markerLength)? true :false;
                  var getaddress = function(i){
                    geocoder.geocode({'address':marker.address},function(results,status){
                      if (status == google.maps.GeocoderStatus.OK) {
                        latlng[0] = results[0].geometry.location.lat();
                        latlng[1] = results[0].geometry.location.lng();
                        // if(is_last){
                        //   $d_setMarker.resolve();
                        // }
                        $d_getAddrs.resolve(latlng);
                      } else { // ジオコーディングが成功しなかった場合
                        console.error('Geocode was not successful for the following reason: ' + status);
                      }
                    });
                    return $d_getAddrs;
                  };
                  if(marker.latlng != undefined ){
                    latlng = marker.latlng.split(',');
                    _this.getmapByLatlng( map, latlng, marker, bounds ).done(function(){
                      if(is_last){
                        $d_setMarker.resolve(bounds);
                      }
                    });
                  }else{
                    getaddress(i).done(function(result){
                      _this.getmapByLatlng( map, latlng, marker, bounds ).done(function(){
                        $d_setMarker.resolve(bounds);
                      });
                    });
                  }
                });
                return $d_setMarker;
              };
              setMarker().done(function(bounds){
                if(opt.centerAdjust != ''){
                  var centerLatlng = bounds.getCenter(),
                      newLatlng = {
                        lat:centerLatlng.lat() + parseFloat(opt.centerAdjust.lat),
                        lng:centerLatlng.lng() + parseFloat(opt.centerAdjust.lng)
                      };
                  var newLatlngobj = new google.maps.LatLng(newLatlng.lat,newLatlng.lng);
                  map.setCenter( newLatlngobj );
                }else if(markers.length > 1){
                  map.fitBounds(bounds);
                }
              });
              if(opt.styleObj != ''){
                _this.setStyle( map, opt.styleObj );
              }
            },
            getmapByLatlng: function(map,latlng,markerOpt,bounds){
              var latlngobj = new google.maps.LatLng( latlng[0], latlng[1] ),
                  zIndex = markerOpt.zIndex || 1,
                  $d_getmapByLatlng = new $.Deferred;

              bounds.extend(latlngobj);
              if(opt.markers.length == 1){
                map.setCenter(latlngobj);
              }
              var marker = new google.maps.Marker({
                map: map,
                position: latlngobj,
                zIndex: zIndex
              });
              if(markerOpt.icon !== undefined && markerOpt.icon != ''){
                marker.setOptions({icon:markerOpt.icon});
                if(markerOpt.iconSize !== undefined && markerOpt.icon != ''){
                  var iconSize = markerOpt.iconSize.split(',');
                  marker.setOptions({icon:{
                    url: markerOpt.icon,
                    scaledSize : new google.maps.Size(iconSize[0],iconSize[1])
                  }});
                }
              }
              if(opt.tooltip){
                var tooltipOpts = {
                  content : '\
                    <div class="poi-info-window gm-style">\
                      <div style="font-size:1.2rem;">\
                        <div class="title full-width" style="font-size:1.2em;">'+markerOpt.title+'</div>\
                        <div class="address">\
                          <div class="address-line full-width">'+markerOpt.address+'</div>\
                        </div>\
                      </div>\
                      <div class="view-link">\
                        <a target="_blank" style="color: #427fed;" href="https://maps.google.com/maps?ll='+latlng.join()+'&amp;q='+latlng.join()+'&amp;z='+opt.zoom+'&amp;hl=ja">\
                          <span>Googleマップで見る</span>\
                        </a>\
                      </div>\
                    </div>\
                    ',
                };
                var tooltip = new google.maps.InfoWindow(tooltipOpts);
                google.maps.event.addListener(marker, "click", function(){
                  //先に開いた情報ウィンドウがあれば、closeする
                  if (currentInfoWindow) {
                    currentInfoWindow.close();
                  }
                  //情報ウィンドウを開く
                  tooltip.open(map, marker);
                  currentInfoWindow = tooltip;
                });
              }
              return $d_getmapByLatlng.resolve();
            },
            setStyle: function(map,mapStyle){
              var g_mapStyle = new google.maps.StyledMapType(mapStyle.style, mapStyle.name);
              map.mapTypes.set( mapStyle.name, g_mapStyle);
              map.setMapTypeId( mapStyle.name);
            }
          };
        }($,opt,null));
    this.reload = function(reloadOption){
      opt = $.extend(true,opt,reloadOption);
      maps_init.createMap(this[0]);
    };
    return this.each(function(){
      maps_init.createMap(this);
    });
  };
}(window,document,$));